// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"338":"2639ba15","493":"76040f01","994":"0ae91719"}[chunkId] + ".chunk.css";
};